/* Sharper responsive sizing for <tag-image> product card images.
   Replaces the theme's getSize(): requests at least 2x (up to 3x) the displayed
   width instead of 1x/2x, and only touches URLs that use the width=50 placeholder. */
(function () {
  if (window.__tagImageSharp) return;
  window.__tagImageSharp = true;

  function patch() {
    var C = customElements.get('tag-image');
    if (!C || C.prototype.__sharpPatched) return;
    C.prototype.__sharpPatched = true;

    C.prototype.getSize = function (value) {
      if (this._cachedSize && !value && this._cachedWidth === window.innerWidth) {
        return this._cachedSize;
      }
      var w = value ? value : Math.round(this.offsetWidth || this.getBoundingClientRect().width);
      if (!w) return false;

      var dpr = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3);
      w = Math.min(Math.ceil(w * dpr), 1600);

      var result = String(this.image_src).replace(/width=50(?!\d)/, 'width=' + w);
      if (!value) {
        this._cachedWidth = window.innerWidth;
        this._cachedSize = result;
      }
      return result;
    };
  }

  customElements.whenDefined('tag-image').then(patch);
})();